import { RJSFSchema } from "shared/types/RJSF"

const childArrayPropsNames = ["anyOf", "allOf", "oneOf"] as const

export function filterSchemaProperties(
  schema: RJSFSchema,
  predicate: (schema: RJSFSchema, id: string) => boolean
): RJSFSchema | null {
  const childArrayPropsName = childArrayPropsNames.find(
    propName => schema[propName]
  )

  if (childArrayPropsName) {
    const subSchemas =
      schema[childArrayPropsName]?.reduce((acc, subSchema) => {
        const filteredSchema = filterSchemaProperties(subSchema, predicate)
        if (filteredSchema) {
          return [...acc, filteredSchema]
        }
        return acc
      }, [] as RJSFSchema[]) || []

    if (!subSchemas) return null

    return {
      ...schema,
      [childArrayPropsName]: subSchemas
    }
  }

  if (!schema.properties) {
    return schema
  }

  const filteredEntries = Object.entries(schema.properties)
    .filter(([key, value]) => predicate(value, key))
    .map(([key, value]) => [key, filterSchemaProperties(value, predicate)])

  if (filteredEntries.length === 0) {
    return null
  }

  return {
    ...schema,
    properties: schema.properties
      ? Object.fromEntries(filteredEntries)
      : schema.properties
  }
}
